<div lang="en" class="light-style layout-navbar-fixed layout-menu-fixed layout-compact" 
[ngClass]="{ 'layout-menu-expanded': isMobile && isMobileView ,
  'layout-menu-collapsed':isCollasepedflag==true}" dir="ltr" data-theme="theme-default" data-assets-path="../../assets/" data-template="vertical-menu-template" data-style="light">
<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <!-- Menu -->
    <app-callcenter-navbar></app-callcenter-navbar>

   <app-callcenter-sidebar></app-callcenter-sidebar>
    <!-- / Menu -->
    <!-- Layout container -->
    <div class="layout-page ">
      <!-- Content wrapper -->
      <div class="content-wrapper" >
        <!-- Content -->

        <router-outlet></router-outlet>

        <!-- / Content -->

        <!-- Footer -->
        <footer class="content-footer footer bg-footer-theme">
        
        </footer>
        <!-- / Footer -->

        <div class="content-backdrop fade"></div>
        <div class="layout-overlay layout-menu-toggle"></div>
        <div class="card rounded-0 cutom-arrowmenu d-none d-md-block" id="template-customizer" style="visibility: visible">
          <button class="template-customizer-open-btn" (click)="togglecollapsedScreen(isCollasepedflag)">
            <img  src="../../../assets/images/new-table/forwardarrow.png" [ngClass]="isCollasepedflag==true ?'':'on'"> 
          </button>
        </div>
      </div>
      <!-- Content wrapper -->
    </div>
    <!-- / Layout page -->
  </div>
</div>
</div>
